import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d40ab52")

_pushScopeId("data-v-1d40ab52")
const _hoisted_1 = {
  key: 0,
  class: "pp-widget-content"
}
const _hoisted_2 = { class: "pp-widget-button" }
const _hoisted_3 = { class: "pp-widget-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", {
    class: "pp-widget-initialized",
    "data-entry-point": _ctx.entryPoint,
    "data-vdp-url": _ctx.vdpUrl,
    "data-vin": _ctx.vin,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPrecisePrice && _ctx.openPrecisePrice(...args)))
  }, [
    (!_ctx.custom)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.text), 1)
          ])
        ]))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          innerHTML: _ctx.custom
        }, null, 8, ["innerHTML"]))
  ], 8, ["data-entry-point", "data-vdp-url", "data-vin"])), [
    [_vShow, _ctx.display]
  ])
})